// MessageCount.tsx
import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import { api } from '@api'
import { AppTooltip } from '@components/AppTooltip'
import { useQuery } from '@tanstack/solid-query'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'
import { promptTooltipClass } from '../../promptTooltipClass'

async function fetchMessageCount(channelId: string): Promise<number> {
  const sb = api()
  const { count, error } = await sb
    .from('message')
    .select('id', { count: 'exact', head: true })
    .eq('channel_id', channelId)

  if (error) throw error
  return count ?? 0
}

export const MessageCount = (props: { channelId?: string | null }) => {
  const q = useQuery(() => ({
    queryKey: ['message-count', props.channelId],
    queryFn: () => fetchMessageCount(props.channelId!),
    enabled: !!props.channelId,
    staleTime: 30 * 60 * 1000, // 30m cache freshness
    gcTime: 30 * 60 * 1000, // 30m cache retention
    retry: 1,
    placeholderData: 0,
  }))

  return (
    <AppTooltip
      delay={900}
      content='Setup Chat'
      contentClass={promptTooltipClass}
    >
      <Badge
        justifyContent="center"
        h='25px'
        px='11px'
        borderRadius='8px'
        class={css({
          bg: 'color-mix(in srgb, var(--colors-red-9) 15%, var(--colors-gray-surface-bg))',
          color: 'red.9',
        })}
      >
        <Show
          when={!q.isLoading}
          fallback="…"
        >
          <Text
            fontSize='11.5px'
            fontWeight='700'
          >
            {q.data ?? 0}
          </Text>
        </Show>
      </Badge>
    </AppTooltip>
  )
}
